export const SET = '/tickets/set';
